export default __webpack_public_path__ + "static/media/termsIcon.20a64eb5.svg";